import { useQuery } from 'react-query';

import { getRecord } from '../utils/backend-api/universal';

export const NEWSLETTER_KEY = 'NEWSLETTER';

export default function useCurrentNewsletter(newsletterId: number) {
  const { data } = useQuery(
    NEWSLETTER_KEY,
    async () =>
      await getRecord({
        id: newsletterId,
        model: 'Newsletter',
        attributes: ['description', 'landing_page_description', 'frequency', 'name'],
        helpers: ['card_image_url_imgix'],
        relations: {
          author: { attributes: ['name'] },
        },
      })
  );

  return { newsletter: data?.result };
}
